export const HomeDetailsHeaderRoutes = {
  activity: 0,
  inquiries: 1
};

export type HomeDetailsHeaderTabNames = keyof typeof HomeDetailsHeaderRoutes;
